window.addGiftToCart = async (giftId, bundleId = null) => {
  if (!giftId) return;

  let properties = { _Regalo: "Sí" };
  if (bundleId) {
    properties["_BundleId"] = bundleId;
  }

  try {
    const resp = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: giftId,
            quantity: 1,
            properties: properties,
          },
        ],
      }),
    });

    if (resp.ok) {
      if (window.refreshCartDrawer) await window.refreshCartDrawer();
      if (window.forceBagCorrection) await window.forceBagCorrection();
    }
  } catch (e) {
    console.error("[GiftDebug] Error agregando bolsa:", e);
  }
};

window.updateCardProductImages = (element) => {
  const cardWrapper = element.closest('.card-wrapper');
  const images = cardWrapper?.getElementsByClassName('featured_image');
  if (!element.dataset.featuredImg || !images?.length) return;

  const featuredImgURL = element.dataset.featuredImg;
  const secondImgURL = element.dataset.secondImg || featuredImgURL;
  images[0].src = featuredImgURL;
  images[0].srcset = featuredImgURL;

  if (images[1]) {
    images[1].src = secondImgURL;
    images[1].srcset = secondImgURL;
  }
};

window.updateCardProductPrice = (element) => {
  const cardWrapper = element.closest('.card-wrapper');
  if (!cardWrapper) return;

  const priceContainer = cardWrapper.querySelector('.price__container');
  if (!priceContainer) return;

  const price = element.dataset.price;
  const compareAtPrice = element.dataset.compareAtPrice;
  const hasCompare = element.dataset.hasCompare === 'true';

  const priceWrapper = cardWrapper.querySelector('.price');
  const existingDiv = priceContainer.querySelector('.price__sale') || priceContainer.querySelector('.price__regular');
  if (!existingDiv) return;

  if (hasCompare && compareAtPrice) {
    priceWrapper.classList.add('price--on-sale');
    priceWrapper.classList.remove('price--no-compare');

    const saleDiv = document.createElement('div');
    saleDiv.className = 'price__sale';
    saleDiv.innerHTML = `
      <span class="visually-hidden visually-hidden--inline">Precio regular</span>
      <span>
        <s class="price-item price-item--regular">${compareAtPrice}</s>
      </span>
      <span class="visually-hidden visually-hidden--inline">Precio de oferta</span>
      <span class="price-item price-item--sale price-item--last price-item--sale-with-compare">
        ${price}
      </span>
    `;
    existingDiv.replaceWith(saleDiv);
  } else {
    priceWrapper.classList.remove('price--on-sale');

    const regularDiv = document.createElement('div');
    regularDiv.className = 'price__regular';
    regularDiv.innerHTML = `
      <span class="price-item price-item--regular">
        ${price}
      </span>
    `;
    existingDiv.replaceWith(regularDiv);
  }
};

window.validateVariantSelected = (element, variantId) => {
  const cardWrapper = element.closest('.card-wrapper');
  if (!cardWrapper) return;

  const titleElement = cardWrapper.querySelector('.js-card-title');
  if (titleElement && element.dataset.variantName) {
    const variantName = element.dataset.variantName;
    titleElement.innerText = variantName === 'Default Title' 
      ? element.dataset.productTitle 
      : element.dataset.productTitle + ' ' + variantName;
  }

  const badgeDiscount = cardWrapper.querySelector('.badge-discount');
  if (badgeDiscount) {
    const discountValue = parseInt(element.dataset.discount);
    if (discountValue > 0) {
      badgeDiscount.innerText = '-' + discountValue + '%';
      badgeDiscount.style.display = 'block';
      badgeDiscount.classList.add('active');
    } else {
      badgeDiscount.style.display = 'none';
      badgeDiscount.classList.remove('active');
    }
  }

  const variantInputs = cardWrapper.querySelectorAll('.product-variant-id');
  variantInputs.forEach(input => input.value = variantId);

  const customButtons = cardWrapper.querySelectorAll('.custom-plp-add-btn');
  const isAvailable = !element.classList.contains('available-false');
  customButtons.forEach(btn => {
    btn.setAttribute('data-variant-id', variantId);
    btn.disabled = !isAvailable;
    const spanText = btn.querySelector('span');
    if (spanText) {
      spanText.innerText = isAvailable ? 'Agregar al carrito' : 'Agotado';
    }
  });

  const siblings = element.parentElement.children;
  Array.from(siblings).forEach(sibling => sibling.classList.remove('active'));
  element.classList.add('active');

  window.updateCardProductImages(element);
  window.updateCardProductPrice(element);
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.variant-option-container ul').forEach(ul => {
    if (ul.querySelector('li.active')) return;
    const first = ul.querySelector('li.available-true') || ul.querySelector('li');
    if (first) first.classList.add('active');
  });
});

// Force autoplay for background videos on mobile
document.addEventListener('DOMContentLoaded', () => {
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('video[data-video-autoplay]').forEach(video => {
    videoObserver.observe(video);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', async (e) => {
    const btn = e.target.closest('.custom-plp-add-btn');
    if (!btn || btn.classList.contains('loading')) return;

    btn.classList.add('loading');
    btn.disabled = true;

    const spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    try {
      const variantId = btn.getAttribute('data-variant-id');
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      const bundledItem = cart.items.find(
        item => item.variant_id == variantId && item.properties?._BundleId
      );

      const props = bundledItem ? { _BundleId: bundledItem.properties._BundleId } : {};

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: props,
        }),
      });

      await response.json();

      if (window.forceBagCorrection) await window.forceBagCorrection();
      if (window.refreshCartDrawer) await window.refreshCartDrawer();

      const drawerInner = document.querySelector('.drawer__inner');
      if (drawerInner) {
        fetch('/cart.js')
          .then(r => r.json())
          .then(cartData => {
            if (cartData.item_count > 0) {
              drawerInner.classList.add('cart-drawer-pinflag-flex-column', 'cart-drawer-pinflag-width');
            } else {
              drawerInner.classList.remove('cart-drawer-pinflag-flex-column', 'cart-drawer-pinflag-width');
            }
          })
          .catch(err => console.warn('Error verificando estado del carrito:', err));
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        setTimeout(() => {
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            cartDrawer.classList.add('active');
          }
        }, 200);
      }
    } catch (error) {
      console.error('Error al agregar al carrito:', error);
    } finally {
      btn.classList.remove('loading');
      btn.disabled = false;
      if (spinner) spinner.classList.add('hidden');
    }
  });
});

// Randomizar frases del badge de colección (1 frase aleatoria por instancia)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.badge-text--collection').forEach((node) => {
    const phraseEls = node.querySelectorAll('.badge-phrase');
    const phrases = Array.from(phraseEls)
      .map((el) => (el.textContent || '').trim())
      .filter(Boolean);

    if (!phrases.length) return;

    const chosen = phrases[Math.floor(Math.random() * phrases.length)];
    node.textContent = chosen;
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const mobileSortBar = document.getElementById('SortBy-mobile-bar');
  const mobileSortDrawer = document.getElementById('SortBy-mobile');
  
  if (mobileSortBar && mobileSortDrawer) {
    mobileSortBar.addEventListener('change', function() {
      mobileSortDrawer.value = this.value;
    });
    mobileSortDrawer.addEventListener('change', function() {
      mobileSortBar.value = this.value;
    });
  }
});
